'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'alarm-exclamation';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f843';
var svgPathData = ['M48 288a208 208 0 1 0 416 0 208 208 0 1 0 -416 0zM272 400a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM241.8 174.7c-.3-8 6.1-14.7 14.2-14.7l2.9 .3c6.6 1.4 11.5 7.4 11.3 14.4L264 336.3c-.2 4.3-3.7 7.7-8 7.7s-7.8-3.4-8-7.7l-6.2-161.6z', 'M256 64c123.7 0 224 100.3 224 224 0 59-22.8 112.6-60.1 152.6l57.7 57.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-57.7-57.7C368.6 489.2 315 512 256 512s-112.6-22.8-152.6-60.1L45.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l57.7-57.7C54.8 400.6 32 347 32 288 32 164.3 132.3 64 256 64zm0 16a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 336a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm2.9-255.7c6.6 1.4 11.5 7.4 11.3 14.4L264 336.3c-.2 4.3-3.7 7.7-8 7.7s-7.8-3.4-8-7.7l-6.2-161.6c-.3-8 6.1-14.7 14.2-14.7l2.9 .3zM95.2 0c23.6 0 45.2 8.6 61.9 22.8 4.4 3.7 2.7 10.6-2.7 12.7-3 1.2-6.3 .5-8.8-1.5-13.7-11.3-31.3-18.1-50.4-18.1-43.8 0-79.2 35.5-79.2 79.2 0 14 3.7 27.2 10.1 38.7 1.6 2.8 1.6 6.2-.1 8.9-3.1 4.9-10.1 5.3-13 .3-8.2-14.1-12.9-30.5-12.9-47.9 0-52.6 42.6-95.2 95.2-95.2zM416.7 0c52.6 0 95.3 42.6 95.3 95.2 0 17.5-4.7 33.9-12.9 47.9-2.9 5-9.9 4.5-13-.3-1.7-2.7-1.7-6.1-.1-8.9 6.4-11.4 10.1-24.6 10.1-38.7 0-43.8-35.5-79.2-79.3-79.2-19.1 0-36.7 6.8-50.4 18.1-2.5 2-5.8 2.7-8.8 1.5-5.3-2.2-7-9-2.7-12.7 16.6-14.2 38.3-22.8 61.9-22.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAlarmExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;